var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.843 13.414a.203.203 0 00-.332-.157c-1.575 1.282-4.548 1.96-7.395 1.96-2.847 0-5.821-.678-7.397-1.96a.202.202 0 00-.331.157v1.396c0 1.798 3.46 3.254 7.728 3.254 4.267 0 7.727-1.456 7.727-3.254v-1.396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.388 11.15c0 1.797 3.46 3.253 7.728 3.253 4.267 0 7.727-1.456 7.727-3.253V9.754a.203.203 0 00-.332-.158c-1.575 1.283-4.548 1.96-7.395 1.96-2.847 0-5.821-.677-7.397-1.96a.203.203 0 00-.331.158v1.396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.116 7.896c-2.847 0-5.821-.678-7.397-1.961a.203.203 0 00-.331.157V7.49c0 1.798 3.46 3.254 7.728 3.254 4.267 0 7.727-1.456 7.727-3.254V6.093a.203.203 0 00-.332-.157c-1.576 1.283-4.548 1.96-7.395 1.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.116 7.082c4.268 0 7.727-1.456 7.727-3.253 0-1.797-3.46-3.254-7.727-3.254C3.848.575.388 2.032.388 3.829s3.46 3.253 7.728 3.253z"
  }))));
}
export default SvgDatabase3;